const theme = {
  colors: {
    primary: '#4A6741',
    primaryDark: '#3B5534',
    primaryLight: '#EDF2EB',
    primaryGradient: 'linear-gradient(135deg, #3B5534 0%, #4A6741 100%)',
    headerGradient: 'linear-gradient(135deg, #2C3640 0%, #3D4F5F 50%, #4A6741 100%)',

    secondary: '#2C3640',
    secondaryLight: '#3D4F5F',

    gold: '#C5A55A',
    goldDark: '#A8893E',
    goldLight: '#F8F3E8',

    accent: {
      blue: '#5C7A8A',
      blueLight: '#E8EEF2',
      green: '#4A6741',
      greenLight: '#EDF2EB',
      red: '#C0392B',
      redLight: '#FDECEA',
      orange: '#D4A62A',
      orangeLight: '#FDF6E3',
      purple: '#6B5B7B',
      purpleLight: '#F0ECF4',
    },

    text: {
      primary: '#1E2A32',
      secondary: '#5A6B75',
      hint: '#8C9AA4',
      white: '#FFFFFF',
    },

    background: {
      default: '#F5F5F0',
      paper: '#FFFFFF',
      card: '#FFFFFF',
      dark: '#2C3640',
    },

    border: '#D9DDD6',
    divider: '#ECEEE9',

    status: {
      requested: '#D4A62A',
      quoted: '#5C7A8A',
      accepted: '#6B5B7B',
      paid: '#4A6741',
      shipped: '#5C6BC0',
      completed: '#4A6741',
      rejected: '#C0392B',
    },
  },

  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '20px',
    round: '50%',
    pill: '999px',
  },

  shadow: {
    small: '0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.08)',
    large: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  fontSize: {
    xs: '11px',
    sm: '13px',
    md: '15px',
    lg: '17px',
    xl: '20px',
    xxl: '24px',
    title: '28px',
  },
};

export default theme;
